<div class="layout-menu-wrapper" [ngClass]="{'layout-sidebar-active': appSidebarService.sidebarActive}"
     (click)="main.onSidebarClick($event)" (mouseover)="main.onSidebarMouseOver($event)" (mouseleave)="main.onSidebarMouseLeave($event)">
    <div class="menu-logo" *ngIf="!main.isHorizontal() || main.isMobile()">

        <a [routerLink]="['/']" class="logo">
            <img [height]="'height: 3rem;'" [src]="'assets/images/logo-'+ (appColorSchemeService.colorScheme === 'light' ? 'dark' : 'light') + '.png'">
        </a>

        <a [routerLink]="['/']" class="app-name" *ngIf="!main.isSlim() || main.isMobile()">
            <img [height]="'height: 3.1rem;'" [src]="'assets/images/appname-'+ (appColorSchemeService.colorScheme === 'light' ? 'dark' : 'light') + '.png'"/>
        </a>
        <a href="#" class="menu-pin" (click)="main.onToggleMenu($event)">
            <span *ngIf="main.isOverlay()" class="fa fa-times fa-fw"></span>
            <span *ngIf="main.isSidebar() && !appSidebarService.sidebarStatic && main.pinActive" class="fa fa-unlock fa-fw"></span>
            <span *ngIf="main.isSidebar() && appSidebarService.sidebarStatic && main.pinActive" class="fa fa-lock fa-fw"></span>
        </a>
    </div>

    <div class="layout-menu-container">
        <ul class="layout-menu">
            <ng-container *ngFor="let item of model; let i = index;">
                <li mx-menuitem *ngIf="!item.separator && item.visible" [item]="item" [index]="i" [root]="true"></li>
                <li *ngIf="item.separator" class="menu-separator"></li>
            </ng-container>
        </ul>
    </div>

    <mx-inlinemenu></mx-inlinemenu>
</div>
